import React, { Component } from 'react';
//import MetaTags from '../helpers/MetaTags';
import Destaque from '../blocks/Destaque.js'
import Contato from '../blocks/Contato.js';
export class Adesao extends Component {
    
    constructor( props ){

        super();

        this.state = {
            isLoaded: false
        }

    }

    render() {
        
        const { siteData } = this.props;

        return (
            <React.Fragment>
                <Destaque context="fale-conosco" size="small" />
                <div className="page single fale-conosco">
                    <div className="wcf">
                        <section id="duvidas" className="duvidas">
                            <div className="wcf">
                                <Contato siteData={siteData} title="Fale com a gente" />
                            </div>
                        </section>
                    </div>
                </div>
            </React.Fragment>
        );
  
    }
    
} 
export default Adesao;